Hexagon = function(dispatcher,scene,texture,angle,y,data) {

	/*---------------------------------------------------
		STATIC
	--------------------------------------------------*/
	this.hotspotData = data;
	this.diameter = 3;
	this.texture = texture;
	this.animationTime = 2.5;
	this.lineThickness = 2;
	this.lineThicknessClose = 6;
	this.radius = 25;

	/*---------------------------------------------------
		variables
	--------------------------------------------------*/
	this.dispatcher = dispatcher;
	this.hexContainer = new THREE.Group(); // FORCES IT TO LOOK AT CENTER
	this.hexGroup = new THREE.Group(); // CONTAINS ALL CHILDRE SO WE CAN ROTATE IT FREELY WITHOUT INTERFERING LOOKAT
	this.y = y;
	this.angle = angle;
	this.position = new THREE.Vector3();

	this.scene = scene;
	this.currentSide = 0;
	this.x = 0;
	//ADD SCOPE TO FUNCTIONS
	this.render = this.render.bind( this );
	this.animateFrame = false;
	this.hit = false;
	this.init();

};



Hexagon.prototype = {

	
	constructor: Hexagon,
	
	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function(){
		//store init position
		this.position = this.getPosition(this.y,this.radius);
		//create hexagons
		this.createIcon();

		this.createHexagons();

		this.createHitPoint();
		
		this.createAnims();

		this.unDrawGeom();

	},

	/*---------------------------------------------------
		FUNCTIONS TO CALL EXTERNALLY
	--------------------------------------------------*/


	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/
	createIcon : function(){
		var texture = this.getTexture("hotspotIcon");

		var geometry = new THREE.PlaneBufferGeometry( 1.5, 1.5, 1 );
		var material = new THREE.MeshBasicMaterial( { color : 0xffffff, map : texture, transparent : true, depthWrite : false, opacity : 0.5 } );

		this.crossIcon = new THREE.Mesh( geometry, material );
		this.hexContainer.add( this.crossIcon );
	},

	createHexagons : function(){
	
		//external border line
		this.frameHexExternalBk = this.createHexMeshLine(1.2, 0xffffff, this.lineThickness, 0.3  );

		this.frameHexExternal = this.createHexMeshLine(1.2, 0x00f6ff, 6, 1);
		this.frameHexExternal.position.z = 0.1;

		this.frameHexInternal = this.createHexMeshLine(1.01, 0xffffff, 5 ,1);
		//OUTLINE

		this.frameHexExternal.geometry.attributes.position.needsUpdate = true;

		this.imageHex  = this.createHexMesh();

		this.hexContainer.add(this.hexGroup);

		this.scene.add( this.hexContainer );

		this.hexContainer.position.set( this.position.x, this.position.y , this.position.z + 2 );
		this.hexContainer.lookAt(0,0,2);
	},
	
	createAnims: function(){

		this.hexAnim = TweenMax.to(this, this.animationTime, { x : 1, ease:  Power4.easeInOut, onComplete:this.zoomIN.bind( this ) });
		this.hexAnim.pause();	

		this.pulsateAnim = TweenMax.to(this.hexContainer.scale, 0.6, { x : 1.2, y : 1.2, ease : Power4.easeInOut, repeat : -1, repeatDelay:0, yoyo: true});
		this.pulsateAnim.pause();
	},
	
	createHitPoint : function(){
		var geometry = new THREE.PlaneBufferGeometry( 10, 10, 1 );
		var material = new THREE.MeshBasicMaterial( { color : 0xffffff, side : THREE.DoubleSide, depthWrite : false, opacity : 0, transparent : true } );
		var plane = new THREE.Mesh( geometry, material );
		plane.scope = this;
		plane.position.z = 0.2
		this.hexContainer.hitPoint = plane;
		this.hexContainer.add( plane );
	},

	getTexture : function(id){
		var texture = new THREE.Texture(app.loader.getItem(id));
		texture.needsUpdate = true;
		return texture;
	},
	
	getGeometry : function() {

		var geometry = new THREE.Geometry();

		geometry.vertices.push( new THREE.Vector3( 0 ,  this.diameter / 2 , 0 ) );
		geometry.vertices.push( new THREE.Vector3( this.diameter * 0.433 ,  this.diameter / 4 , 0 ) );
		geometry.vertices.push( new THREE.Vector3( this.diameter * 0.433 , - this.diameter / 4 , 0 ) );
		geometry.vertices.push( new THREE.Vector3( 0 , - this.diameter / 2 , 0 ) );
		geometry.vertices.push( new THREE.Vector3( -this.diameter * 0.433 , - this.diameter / 4 , 0 ) );
		geometry.vertices.push( new THREE.Vector3( -this.diameter * 0.433 ,  this.diameter / 4 , 0 ) );
		geometry.vertices.push( new THREE.Vector3( 0 ,  this.diameter / 2 , 0 ) );

		return geometry;
	},

	getBufferGeometry : function() {
		var positions = new Float32Array( 7 * 3 );
		var positions2 = new Float32Array( 7 * 3 );

		positions2[ 0 ] = positions[ 0 ] = 0;
		positions2[ 1 ] = positions[ 1 ] =  this.diameter / 2;
		positions2[ 2 ] = positions[ 2 ] = 0;

		positions2[ 3 ] = positions[ 3 ] = this.diameter * 0.433;
		positions2[ 4 ] = positions[ 4 ] =  this.diameter / 4;
		positions2[ 5 ] = positions[ 5 ] = 0;
		
		positions2[ 6 ] = positions[ 6 ] = this.diameter * 0.433;
		positions2[ 7 ] = positions[ 7 ] = -this.diameter / 4;
		positions2[ 8 ] = positions[ 8 ] = 0;
		
		positions2[ 9 ]  = positions[ 9 ]  = 0;
		positions2[ 10 ] = positions[ 10 ] = -this.diameter / 2;
		positions2[ 11 ] = positions[ 11 ] = 0;
		
		positions2[ 12 ] = positions[ 12 ] = -this.diameter * 0.433;
		positions2[ 13 ] = positions[ 13 ] = -this.diameter / 4;
		positions2[ 14 ] = positions[ 14 ] = 0;
		
		positions2[ 15 ] = positions[ 15 ] = -this.diameter * 0.433;
		positions2[ 16 ] = positions[ 16 ] = this.diameter / 4;
		positions2[ 17 ] = positions[ 17 ] = 0;
	   
		positions2[ 18 ] =  positions[ 18 ] = 0;
		positions2[ 19 ] =  positions[ 19 ] =  this.diameter / 2;
		positions2[ 20 ] =  positions[ 20 ] = 0;
		
		var geometry = new THREE.BufferGeometry();
		geometry.addAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );

		geometry.addAttribute( 'final_position', new THREE.BufferAttribute( positions2, 3 ) );

		return geometry;

	},
	
	unDrawGeom : function(){

		this.frameHexExternal.geometry.setDrawRange( 0, 0 );

	},
	
	resetFrame : function(){

		var endPos = this.frameHexExternal.geometry.attributes.final_position.array;
		var currentPos = this.frameHexExternal.geometry.attributes.position.array;
		var l  = endPos.length;
		for(var i = 0; i < l; i++){
			currentPos[ i ] = endPos[ i ];
		}
		//this.hexContainer.hitPoint.material.opacity = 0;
		//this.frameHexExternal.geometry.attributes.position.needsUpdate = true;
		this.imageHex.material.opacity = 0;
		this.dispatcher.dispatch( EVENTS.SHOW_EXTRA_CONTENT, this.hotspotData );

		this.moveBack();
	},

	generateFaces : function( geometry ){

		var holes = [];
		triangles = THREE.ShapeUtils.triangulateShape( geometry.vertices, holes );

		for( var i = 0; i < triangles.length; i++ ){
		
			geometry.faces.push( new THREE.Face3( triangles[ i ][ 0 ], triangles[ i ][ 1 ], triangles[ i ][ 2 ] ) );
		
		}
		geometry.computeFaceNormals();

	},
	getTextureRanges : function(){
		//LEGACY WE DONT NEED IT I leave this for the future
		var range = {};
		if( this.texture.image.width >= this.texture.image.height ){
			range.yMax = 1;  //( this.texture.image.height / this.texture.image.width ) / 2;
			range.yMin = 0; // (this.texture.image.height / this.texture.image.width ) / 2;
			range.xMax = 1;
			range.xMin = 0;
		}else{
			range.yMax = 1;
			range.yMin = 0;
			range.xMax = 1;// - ( this.texture.image.width / this.texture.image.height ) / 2;
			range.xMin = 0;//( this.texture.image.width / this.texture.image.height ) / 2;
		}

		return range;
	},
	
	resizeTexture : function(){
		var repeatX, repeatY;
		if( this.texture.image.width >= this.texture.image.height ){
			this.texture.wrapS = THREE.ClampToEdgeWrapping;
			this.texture.wrapT = THREE.RepeatWrapping;
			repeatX = 0.866 * this.texture.image.height / ( 1 * this.texture.image.width);
			repeatY = 1;
			this.texture.repeat.set(repeatX, repeatY);
			this.texture.offset.x = ( repeatX - 1 ) / 2 * -1;
		}else{
			this.texture.wrapS = THREE.RepeatWrapping ;
			this.texture.wrapT = THREE.ClampToEdgeWrapping;
			repeatX = 1;
			repeatY = 1 * this.texture.image.width / ( 0.866 * this.texture.image.height);
			this.texture.repeat.set(repeatX, repeatY);
			this.texture.offset.y = ( repeatY - 1 ) / 2 * -1;
		}
		this.texture.needsUpdate = true;
	},

	generateUVS : function( geometry ){
		

		this.resizeTexture();
		geometry.faceVertexUvs[ 0 ] = [];

		geometry.computeBoundingBox();
		var max = geometry.boundingBox.max;
		var min = geometry.boundingBox.min;
		
		var offset = new THREE.Vector2( 0 - min.x, 0 - min.y );
		//offset.y = offset.y*(1080/1920)
		var range = new THREE.Vector2( max.x  - min.x, max.y  - min.y );
		//console.log(range.y)
		var textureRange = this.getTextureRanges();

		var faces = geometry.faces;
		
		for (var i = 0; i < faces.length ; i++) {
		
			var v1 = geometry.vertices[ faces[ i ].a ],
				v2 = geometry.vertices[ faces[ i ].b ],
				v3 = geometry.vertices[ faces[ i ].c ];
		//
			geometry.faceVertexUvs[ 0 ].push([
				new THREE.Vector2( ( ( v1.x + offset.x ) / range.x) * ( textureRange.yMax - textureRange.yMin ) + textureRange.yMin, (( v1.y + offset.y ) / range.y ) * ( textureRange.xMax - textureRange.xMin ) + textureRange.xMin ),
				new THREE.Vector2( ( ( v2.x + offset.x ) / range.x) * ( textureRange.yMax - textureRange.yMin ) + textureRange.yMin, (( v2.y + offset.y ) / range.y ) * ( textureRange.xMax - textureRange.xMin ) + textureRange.xMin ),
				new THREE.Vector2( ( ( v3.x + offset.x ) / range.x) * ( textureRange.yMax - textureRange.yMin ) + textureRange.yMin, (( v3.y + offset.y ) / range.y ) * ( textureRange.xMax - textureRange.xMin ) + textureRange.xMin )
			]);
		}
		geometry.uvsNeedUpdate = true;
		geometry.computeVertexNormals();

	},
	
	getLineMaterial : function( color , width ,opacity){

		var material = new THREE.LineBasicMaterial({
			color : color,
			transparent : true,
			opacity : opacity,
			linewidth : width,
			blending : THREE.AdditiveBlending
		});

		return material;

	},
	
	createHexMeshLine : function(scale, color, thickness, opacity){

		var geometry = this.getBufferGeometry();

		var material = this.getLineMaterial( color, thickness, opacity );

		var line = new THREE.Line( geometry, material );
		line.scale.set( scale , scale , 1 );
		this.hexGroup.add( line );
		line.scope = this;
		return line;

	},

	createHexMesh : function(){

		var geometry = this.getGeometry();
		this.generateFaces( geometry );
		this.generateUVS( geometry );
		this.texture.needsUpdate = true;
		var material = new THREE.MeshBasicMaterial( { color : 0xffffff, opacity : 0, depthWrite : false, transparent : true, map : this.texture } );
		
		material.map.needsUpdate = true;
		mesh = new THREE.Mesh( geometry, material );
		mesh.scale.set( 1, 1, 1 );
		this.hexGroup.add( mesh );
		mesh.scope = this;
		return mesh;

	},
	
	moveFoward : function(){
		if ( ( this.hit ) ) return;

	
		this.pulsateAnim.pause( 0, true );
		var point = this.position.clone();
		point = this.getPosition(0,7);
		this.movingFoward = true;
		TweenMax.to(this.crossIcon.material, 0.2,  { opacity : 0, ease: Power4.easeInOut } );
		TweenMax.to( this.hexContainer.position, 0.5, { x : point.x, y : point.y, z : point.z,ease: Power4.easeInOut, onComplete : this.moveFowardDone.bind( this ) } );
		this.hit = true;  
		TweenMax.fromTo( this.imageHex.material, 0.5, { delay : 0.2, opacity : 0.4, ease: Power4.easeInOut }, { opacity : 1, ease: Power4.easeInOut } );
		this.imageHex.material.depthWrite = true;
	},

	moveFowardDone : function(){
		this.movingFoward = false;
		
		this.animateFrame = true;
		this.x = 0;
		//PLAY CHARGE SOUND
		this.chargeSoundTW = TweenMax.delayedCall( 0.5, function(){this.dispatcher.dispatch( EVENTS.CHARGE_SOUND_ON );}.bind(this));
			
		this.hexAnim.pause( 0, true );
		this.hexAnim.play();

		this.frameHexExternal.geometry.setDrawRange( 0, 2 );

	},
	
	moveBack : function(){
		if( (this.hit === false) || this.movingBack ) return;

		this.imageHex.material.opacity = 0;
		this.imageHex.material.depthWrite = false;
		//this.hit = false;
		this.hexAnim.pause( 0, true );
		if(this.chargeSoundTW) this.chargeSoundTW.pause();
		this.dispatcher.dispatch(EVENTS.CHARGE_SOUND_OFF );
		this.unDrawGeom();
		this.movingBack = true;
		this.animateFrame = false;
		this.backTw = TweenMax.to( this.hexContainer.position, 0.5, { x : this.position.x, y : this.position.y, z : this.position.z, onComplete:this.moveBackDone.bind( this ) } );
	
	},
	
	moveBackDone : function() {

		TweenMax.to(this.crossIcon.material, 0.2,  { opacity : 0.5, ease: Power4.easeInOut } );
		this.hexContainer.position.z = this.position.z;
		this.hit = false;
		this.movingBack = false;
		this.imageHex.material.opacity = 0;
		this.imageHex.material.depthWrite = false;
		this.pulsateAnim.play( );

	},
	//zooms in image to create transtion with dom element
	zoomIN : function(){
		var point = this.position.clone();
		point = this.getPosition(0,1);
		this.zoomINanim = TweenMax.to( this.hexContainer.position, 0.4, {x : point.x, y : point.y, z : point.z, ease: Power4.easeInOut, onComplete:this.resetFrame.bind( this ) } );
		TweenMax.fromTo( this.imageHex.material, 0.3, { opacity : 1, ease: Power4.easeInOut }, { opacity : 0, ease: Power4.easeInOut } );
		this.dispatcher.dispatch( EVENTS.SHOW_EXTRA_CONTENTANIM, this.hotspotData );

	},

	drawFrame : function(){

		var endPos = this.frameHexExternal.geometry.attributes.final_position.array;
		var currentPos = this.frameHexExternal.geometry.attributes.position.array;

		var percent = this.x;
		var side = Math.floor( percent * 100  / ( 100 / 6 ) );
		var initPos = side * 3;
		   if(side != this.currentSide){
				currentPos[ this.currentSide + 3 ] = endPos[ this.currentSide + 3 ];
				currentPos[ this.currentSide + 4 ] = endPos[ this.currentSide + 4 ];
				this.currentSide = side * 3;
				this.frameHexExternal.geometry.setDrawRange( 0, side + 2 );
			   
		}

		var cp = ( percent -  (side * ( 1 / 6 ) ) ) /  ( 1 / 6 );//calculates linePercent divides by 6 cause we have 6 sides
		
	
		currentPos[ initPos + 3 ] = currentPos[ initPos ] +  -1 * ( currentPos[ initPos ] - endPos[ initPos + 3 ] ) * cp;
		currentPos[ initPos + 4 ] = currentPos[ initPos + 1 ] - ( currentPos[ initPos + 1 ] - endPos[ initPos + 4 ] ) * cp;
	
		this.frameHexExternal.geometry.attributes.position.needsUpdate = true;

	},

	getPosition : function( y, radius ){
		var pos = new THREE.Vector3();
		pos.x = (Math.cos( this.angle * ( Math.PI / 180 ) ) * radius);
		pos.y = (y);
		pos.z = (2 + Math.sin( this.angle * ( Math.PI / 180 ) ) * radius);
		pos.x = Math.round(pos.x * 1000) / 1000;
		pos.y = Math.round(pos.y * 1000) / 1000;
		pos.z = Math.round(pos.z * 1000) / 1000;
		return pos;
	},

	/*---------------------------------------------------
		RENDER
	--------------------------------------------------*/
	render : function (position) {
		this.hexContainer.lookAt( position );
		if( ( this.animateFrame ) && ( this.hexAnim.progress() != 1 ) ){
			this.drawFrame();
		}

	}
};